module.exports = __webpack_public_path__ + "static/media/benefits-gold.e72dcca5.png";